import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { checkAccess } from '@/creditflowresearch/application/User/access';

export const useTopCompaniesAccess = () => {
  const { checkAccessByUserPlan } = useUserPlanContext();
  const { checkAccessByUserRegions, checkAccessByUserProducts } = usePageFiltersContext();
  const checks = [
    checkAccessByUserPlan(UserPlanType.PREMIUM),
    checkAccessByUserRegions(),
    checkAccessByUserProducts(),
  ];
  return checkAccess(checks);
};
